export default "__VITE_ASSET__50d636af__"